function refreshArr(arr, newArr) {
  arr.length = 0
  arr.push(...newArr)
}

export { refreshArr }
